import { useEffect } from 'react'

interface SeoOptions {
  title: string
  description: string
}

function setMeta(name: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute('name', name)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

export function useSeo({ title, description }: SeoOptions) {
  useEffect(() => {
    document.title = title
    setMeta('description', description)
    setMeta(
      'keywords',
      'painting contractor Dallas, drywall contractor Dallas, flooring installation Dallas, LVP flooring, home remodeling Dallas, handyman services Dallas, junk removal Dallas, bilingual contractor Dallas Fort Worth',
    )
  }, [title, description])
}

export function useLocalBusinessSchema() {
  useEffect(() => {
    const id = 'ms-local-business-schema'
    if (document.getElementById(id)) return

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HomeAndConstructionBusiness',
      name: 'M&S Multiservices',
      description:
        'Family-owned painting, drywall, flooring and remodeling contractor serving Dallas-Fort Worth, Texas. Licensed and insured, bilingual English and Spanish, free estimates.',
      telephone: '+1-214-259-5582',
      email: 'ms.multiservices2025@gmail.com',
      priceRange: '$$',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Dallas',
        addressRegion: 'TX',
        addressCountry: 'US',
      },
      areaServed: [
        'Dallas, TX',
        'Fort Worth, TX',
        'Arlington, TX',
        'Plano, TX',
        'Irving, TX',
        'Garland, TX',
        'Frisco, TX',
        'McKinney, TX',
      ],
      knowsLanguage: ['en', 'es'],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '07:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '08:00',
          closes: '16:00',
        },
      ],
      makesOffer: [
        'Interior Painting',
        'Exterior Painting',
        'Drywall Installation & Repair',
        'Laminated Flooring Installation',
        'LVP Flooring Installation',
        'Carpet Installation & Removal',
        'Structure Building & Remodeling',
        'Demolition & Junk Removal',
      ],
    }

    const script = document.createElement('script')
    script.id = id
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify(schema)
    document.head.appendChild(script)
  }, [])
}
